import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { qk } from "@/lib/query-keys";
import { listarIndicadoresImpuestoAdmin } from "../services/indicadores-impuesto-service";

export const indicadoresImpuestoAdminQueryOptions = queryOptions({
  queryKey: qk.adminIndicadoresImpuesto,
  queryFn: listarIndicadoresImpuestoAdmin,
});

export function useIndicadoresImpuestoAdmin() {
  return useSuspenseQuery(indicadoresImpuestoAdminQueryOptions);
}
